export const environment = {
  production: false,
  entityType: 'IP',
  urlDEV: 'https://nstaging-ip-api.certikap.com/api/v1',
  urlDEV_images: 'https://nstaging-ip-api.certikap.com/uploads/users/',
  urlDownload: 'https://nstaging-ip-api.certikap.com/uploads/generated-csv/cron/exports/',
  urlDownloadCertification: 'https://nstaging-ip-api.certikap.com/uploads/generated-csv/certifications/',
  formURL: 'https://nstaging-ip.certikap.com/v1/form/auto-inscription/',
  ELMS_url: 'https://pasteur.elmg.net/',
};
